"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const xstate_1 = require("xstate");
const moment_1 = __importDefault(require("moment"));
const TimeFilter_1 = __importDefault(require("../TimeFilter"));
const GroupedAppts_1 = __importDefault(require("./GroupedAppts"));
const LoadMoreBtn_1 = __importDefault(require("./LoadMoreBtn"));
const styles_1 = require("./styles");
const Banners_1 = require("../../Banners");
const WeekDayFilter_1 = __importDefault(require("../WeekDayFilter"));
const States_1 = require("../../../lib/constants/States");
const ApptList_utils_1 = require("./ApptList.utils");
const configUtils_1 = require("../../../lib/configUtils");
const FilterToolbar_1 = __importDefault(require("../FilterToolbar"));
const messages_1 = __importDefault(require("../../../lib/messages"));
const propTypes_1 = require("../../../lib/propTypes");
const ApptFilters_1 = __importDefault(require("../ApptFilters"));
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
const LocationProp = (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    id: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
    name: prop_types_1.string,
    street1: prop_types_1.string,
    street2: prop_types_1.string,
    suite: prop_types_1.string,
    city: prop_types_1.string,
    state: prop_types_1.string,
    zip: prop_types_1.string
}));
const propTypes = {
    useNewFilters: prop_types_1.bool,
    currentState: (0, prop_types_1.instanceOf)(xstate_1.State).isRequired,
    appointments: prop_types_1.array.isRequired,
    bookableLocations: LocationProp.isRequired,
    nonBookableLocations: LocationProp.isRequired,
    selectedLocationIds: (0, prop_types_1.instanceOf)(Set).isRequired,
    locationId: prop_types_1.string,
    onSelect: prop_types_1.func.isRequired,
    onClearFilters: prop_types_1.func.isRequired,
    onDayOfWeekChange: prop_types_1.func.isRequired,
    onDateChange: prop_types_1.func.isRequired,
    onTimeOfDayChange: prop_types_1.func.isRequired,
    onLoadMore: prop_types_1.func.isRequired,
    onSelectAppt: prop_types_1.func.isRequired,
    onHighlightLocId: prop_types_1.func.isRequired,
    query: prop_types_1.object.isRequired,
    config: propTypes_1.configType,
    track: prop_types_1.func,
    apptDensity: (0, prop_types_1.oneOf)(['default', 'dense']),
    provider: prop_types_1.object.isRequired
};
function ApptList({ useNewFilters, currentState, appointments, bookableLocations, nonBookableLocations, selectedLocationIds, locationId, onSelect, onClearFilters, onDayOfWeekChange, onTimeOfDayChange, onLoadMore, onSelectAppt, onHighlightLocId, query, config, onDateChange, track, apptDensity = 'default', provider }) {
    var _a;
    const { filterBy, periodStart, firstNewAppointmentId, jumpedToDate, featureFlags } = currentState.context;
    const { aboveMd } = (0, useWindowWidth_1.default)();
    (0, react_1.useLayoutEffect)(() => {
        if (firstNewAppointmentId) {
            const slotNode = document.getElementById(firstNewAppointmentId);
            slotNode && slotNode.focus();
        }
    }, [firstNewAppointmentId]);
    const batchedAppointments = (0, react_1.useMemo)(() => {
        return (0, ApptList_utils_1.batchAppointmentsByDay)(appointments, filterBy);
    }, [appointments, filterBy]);
    // Part of a unique key used to detect filtering while rendering the list of
    // batched appointments.
    const timeOfDayKey = `TD:${[...filterBy.timeOfDay.values()].join()}`;
    const locById = bookableLocations.reduce((acc, cur) => {
        acc[cur.id] = cur;
        return acc;
    }, {});
    /**
     * If we don't have any `batchedAppointments` at this point,
     * then it's because they were filtered out.*/
    const noFilteredResults = batchedAppointments.length === 0;
    const noFilters = currentState.context.filterBy.timeOfDay.size +
        currentState.context.filterBy.dayOfWeek.size ===
        0;
    const showNoResultsBanner = noFilteredResults || currentState.matches(`${States_1.jumpToDate}.${States_1.noResults}`);
    const noMoreResults = currentState.matches(`${States_1.nextSearch}.${States_1.noResults}`);
    const noResultsBanner = currentState.matches(`${States_1.jumpToDate}.${States_1.noResults}`) ? (react_1.default.createElement(Banners_1.NoResultsBanner, { resultsMessage: messages_1.default.noJumpToDateResults, date: currentState.context.query.periodStart, onClearFilters: noFilters ? undefined : onClearFilters })) : (react_1.default.createElement(Banners_1.NoResultsBanner, { resultsMessage: noMoreResults
            ? messages_1.default.noFilteredResultsNoMoreResults
            : messages_1.default.noFilteredResults, jumpedToDate: jumpedToDate || (0, moment_1.default)(), date: (_a = appointments[appointments.length - 1]) === null || _a === void 0 ? void 0 : _a.start_datetime, isLoading: currentState.matches(`${States_1.nextSearch}.${States_1.pending}`), onLoadMore: noMoreResults ? undefined : onLoadMore, onClearFilters: noFilters ? undefined : onClearFilters }));
    const renderFilters = () => {
        const isDrawerOrMobile = (0, configUtils_1.isDirectBookRenderedInDrawer)(config, featureFlags) || !aboveMd;
        const isDrawer = (0, configUtils_1.isDirectBookRenderedInDrawer)(config, featureFlags);
        const useJumpDate = (0, ApptList_utils_1.shouldUseJumpToDate)(config);
        if (useNewFilters && isDrawerOrMobile) {
            return (react_1.default.createElement(ApptFilters_1.default, { filterBy: filterBy, onTimeOfDayChange: onTimeOfDayChange, track: track, selectedDate: jumpedToDate, onDateChange: onDateChange, bookableLocations: bookableLocations, nonBookableLocations: nonBookableLocations, selectedLocationIds: selectedLocationIds, locationId: locationId, onSelect: onSelect, onDayOfWeekChange: onDayOfWeekChange }));
        }
        if (useJumpDate && (!isDrawer || !isDrawerOrMobile)) {
            return (react_1.default.createElement(FilterToolbar_1.default, { filterBy: filterBy, onDayOfWeekChange: onDayOfWeekChange, onTimeOfDayChange: onTimeOfDayChange, onDateChange: onDateChange, selectedDate: jumpedToDate, track: track }));
        }
        if (!isDrawer) {
            return (react_1.default.createElement(styles_1.Toolbar, { "data-testid": "ApptList__LegacyFilterBar" },
                react_1.default.createElement(WeekDayFilter_1.default, { filterBy: filterBy, onChange: onDayOfWeekChange }),
                react_1.default.createElement(TimeFilter_1.default, { filterBy: filterBy, onChange: onTimeOfDayChange })));
        }
        return null;
    };
    return (react_1.default.createElement(styles_1.Container, { "data-testid": "ApptList" },
        renderFilters(),
        showNoResultsBanner ? (noResultsBanner) : (react_1.default.createElement(react_1.default.Fragment, null,
            currentState.matches(`${States_1.newSearch}.${States_1.deepLinkingTimeSlotUnavailableError}`) && (react_1.default.createElement(Banners_1.DeepLinkingUnavailableSlotBanner, { slotTime: (0, ApptList_utils_1.formatTimeForErrorMsg)(periodStart) })),
            batchedAppointments.map(({ header, byLocId }) => (react_1.default.createElement(GroupedAppts_1.default, { locById: locById, 
                // key with timeOfDay used for animation to detect filtering
                key: `${header}__${timeOfDayKey}`, header: header, groupByLocId: byLocId, onSelectAppt: onSelectAppt, onHighlightLocId: onHighlightLocId, query: query, shouldUseJumpToDate: (0, ApptList_utils_1.shouldUseJumpToDate)(config), apptDensity: apptDensity, disableExpandCollapse: true, track: track, shouldShowRegulatedSpacesBanner: (0, ApptList_utils_1.shouldShowRegulatedSpacesBanner)(config), provider: provider }))),
            react_1.default.createElement(LoadMoreBtn_1.default, { config: config, currentState: currentState, onClick: onLoadMore })))));
}
exports.default = ApptList;
ApptList.propTypes = propTypes;
//# sourceMappingURL=ApptList.js.map